import { Component, OnInit, Input } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SharedService } from 'src/app/utils/shared.service';
import { HttpClient } from '@angular/common/http';
import { MasterService } from '../master.service';
import * as CommonConstants from '../../utils/common.constants';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-hyper-speciality',
  templateUrl: './add-hyper-speciality.component.html',
  styleUrls: ['./add-hyper-speciality.component.scss']
})
export class AddHyperSpecialityComponent implements OnInit {

  @Input() partnerId: number;
  @Input() partnerType: number;
  hyperSpecialityForm: FormGroup;
  specialities: any[];
  subSpecialities: any[];
  hyperSpecialities:any[];
  submitted = false;
  hyperSpecList: any[] = [];
  columnDefs:any[];
  toggleDiv =true;
  subSpecialitiesFiltered : any[];
  hyperSpecialitiesFiltered:any[];

  constructor(private modalService: NgbModal, private formBuilder: FormBuilder,
    private masterService: MasterService, private sharedService: SharedService, private http: HttpClient,
    private toastrService:ToastrService) {
    this.getHyperSpecFormGroup();

    this.columnDefs = [
      { headerName: 'Hyper Speciality', field: 'hsptyName' },
      { headerName: 'Number Of Beds', field: 'hyptyNuNumberBed'},
      { headerName: 'Number Of Specialists', field: 'hyptyNuNumberSpecialists' }            
    ];
 
  }

  ngOnInit() {
    this.loadMasterData();
    
  }


  loadMasterData() {
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })

    this.masterService.getSubSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.subSpecialities = response['result'];
      }
    })

   
   
      this.masterService.getHyperSpecialities().subscribe(response => {
        if (response && response['result']) {
          this.hyperSpecialities = response['result'];
        }
      })

  }

  hyperSpecialityAddModal(addHyperSpeciality){
    this.modalService.open(addHyperSpeciality, { size: 'lg', container: '.page-content' });
  }

  changeSpeciality(obj) {
    this.hyperSpecialitiesFiltered= [];
    this.hyperSpecialityForm.patchValue({ssptyId:null,hsptyId:null});
    this.subSpecialitiesFiltered = this.subSpecialities.filter(res => {
      return res.spltyId === obj.spltyId
    })
  }

  changeSubSpeciality(obj) {
    this.hyperSpecialityForm.patchValue({hsptyId:null});
    this.hyperSpecialitiesFiltered = this.hyperSpecialities.filter(res => {
      return res.ssptyId === obj.ssptyId
    })
  }


  /**
  * Declare form group
  *  
  */
  private getHyperSpecFormGroup() {
    this.hyperSpecialityForm = this.formBuilder.group({
      'hsptyId': ['', Validators.required],
      'hyptyId': new FormControl(),
      'spltyId': new FormControl(),
      'ssptyId': new FormControl(),
      'hyptyNuNumberBed': new FormControl(),
      'hyptyNuNumberSpecialists': new FormControl(),
      "staRecCode": [true]
    })
  }

  /**
   * To get form controls
   */
  get f() { return this.hyperSpecialityForm.controls; }

  saveHyperSpeciality() {
    this.submitted = true;
    if (this.hyperSpecialityForm.invalid) {
      return;
    }
    let saveData = this.hyperSpecialityForm.value;
    saveData['partnerId'] = this.partnerId;
    saveData['partnerType'] = this.partnerType;
    saveData["staRecCode"]=this.f.staRecCode.value ? 'A' :'I';
    if (this.hyperSpecialityForm.value) {
      this.http.post(CommonConstants.SAVE_PARTNER_HYPER_SPECIALITY, saveData)
        .subscribe(response => {
          if (response['code'] == 0) {
            this.toastrService.success("saved");
            this.modalService.dismissAll("#addHyperSpeciality");
            this.hyperSpecList = this.sharedService.updateDuplicateRecord(response['hsptyId'], this.hyperSpecList,
              "hsptyId", this.hyperSpecialityForm.value);
              this.hyperSpecList =this.hyperSpecList.map(item => ({ ...item, 
                hsptyName: item.hsptyId ? this.hyperSpecialities.find(obj => +obj.hsptyId === +item.hsptyId).hsptyDescEn: null})); 
           
          }
        })
    }
  }

  onHyperSpecRowSelect(spec, addSpec) {
    let data = JSON.parse((JSON.stringify(spec.data)));
    this.modalService.open(addSpec, { size: 'lg', container: '.page-content' });
    this.hyperSpecialityForm.patchValue([data]);
  }

toggleContent(){
  this.toggleDiv = !this.toggleDiv;
}
  

}
